export default "__VITE_ASSET__DUjQaZNj__"